import { render } from "./EtatPointProduitLivraison.vue?vue&type=template&id=2c1fdac8&ts=true"
import script from "./EtatPointProduitLivraison.vue?vue&type=script&lang=ts"
export * from "./EtatPointProduitLivraison.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__